module.exports = __webpack_public_path__ + "img/icon_rlzy.60bef6d4.png";